import categorys from '../utils/categorys.js'
export default {
  state: {
    dialogConfig: {
      status: false,
      mess: '',
      title: '',
      buttons: [],
    }
  },
  getters: {
    dialogConfig(state) {
      return state.dialogConfig
    }

  },
  mutations: {
    setDialogConfig(state, dialogConfig) {
      state.dialogConfig=dialogConfig
    },
  },
  actions: {
    diologConfig({
      commit
    }, dialogConfig) {
      commit('setDialogConfig', dialogConfig);
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dialogStore.js